// resources/js/admin/pages/module-pages/locales/UpdateLocalePage.tsx

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Locale, LocaleFormData } from "../../../types/features/Locale";
import PageLayout from "../../../layouts/PageLayout";
import PageContainer from "../../../components/ui/PageContainer";
import useCustomParams from "../../../hooks/core/useCustomParams";
import { alertSuccess, alertError } from "../../../helpers/alertError";
import useLocales from "../../../hooks/features/locales/useLocales";
import LocaleForm from "../../../components/shared/locales/LocalForm";

export default function UpdateLocalePage() {
    const { id } = useCustomParams();
    const navigate = useNavigate();
    const { fetchLocaleById, updateLocale } = useLocales();
    const [locale, setLocale] = useState<Locale | null>(null);
    const [loading, setLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    useEffect(() => {
        loadLocale();
    }, [id]);

    const loadLocale = async () => {
        if (id) {
            const data = await fetchLocaleById(id);
            if (data) {
                setLocale(data);
            }
            setLoading(false);
        }
    };

    const handleSubmit = async (data: LocaleFormData) => {
        setIsLoading(true);
        const success = await updateLocale(id!, data);
        setIsLoading(false);
        if (success) {
            setIsSuccess(true);
            alertSuccess("Langue mise à jour avec succès");
            navigate("/admin/locales");
        } else {
            alertError("Erreur lors de la mise à jour de la langue");
        }
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
            </div>
        );
    }

    if (!locale) {
        return (
            <div className="flex flex-col items-center justify-center h-64">
                <p className="text-gray-500">Langue non trouvée</p>
                <button
                    onClick={() => navigate("/admin/locales")}
                    className="mt-4 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90"
                >
                    Retour à la liste
                </button>
            </div>
        );
    }

    return (
        <PageLayout title="Modifier la langue" className="p-6 max-w-4xl mx-auto">
            <PageContainer>
                <div className="mb-6">
                    <h1 className="text-2xl font-bold text-gray-900">Modifier la langue</h1>
                    <p className="text-gray-500 mt-1">Modifiez les informations de la langue "{locale.name}"</p>
                </div>
                <LocaleForm
                    isSuccess={isSuccess}
                    initialData={locale}
                    isEdit={true}
                    onSubmit={handleSubmit}
                    isLoading={isLoading}
                />
            </PageContainer>
        </PageLayout>
    );
}